import { createUseStyles } from 'react-jss';
import LogoAlign from '../../assets/LogoAlign.svg';

export default createUseStyles(
  {
    root: {
      height: '50px',
      position: 'fixed',
      width: '100%',
      backgroundColor: '#000000',
      display: 'flex',
      zIndex: 10,
    },

    consoleNameHeader: {
      flex: 1,
      marginLeft: '16px',
      marginTop: '12px',
    },

    user: {
      display: 'flex',
      marginRight: '6px',
    },

    userName: {
      flex: 1,
      marginRight: '8px',
      marginTop: '12px',
      visibility: 'hidden',
      display: 'none',
    },

    userAvatar: {
      paddingTop: '8px',
      visibility: 'hidden',
      display: 'none',
    },

    logoutLink: {
      display: 'flex',
      marginRight: '10px',
      marginTop: '12px',
    },

    logoImage: {
      backgroundImage: `url(${LogoAlign})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      width: '220px',
      height: '28px',
      marginLeft: '30px',
      marginRight: '-150px',
      marginTop: '9px',
    },
    verticalLine: {
      width: '2px',
      height: '32px',
      backgroundColor: '#ffffff',
      marginRight: '12px',
      marginLeft: '3px',
      opacity: 0.5,
      marginTop: '8px',
    },
    appName: {
      width: '200px',
      height: '28px',
      marginLeft: '-2px',
    },
    buildVersion: {
      color: '#ffffff',
      fontSize: '13px',
      marginTop: '8px',
      marginLeft: '-37px',
    },
  },
  {
    name: 'Header',
  },
);
